export const houseEquipment = ["ONT621", "ONT2200", "ONT632V", "ONT622V"];

export const ontFirmwareVersion = '25.1-10';



// WEBPACK FOOTER //
// ./src/constants/houseEquipmentConfig.js